import React from "react";
import * as style from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Card, Container } from "react-bootstrap";
import locale from "locales";
import Link from "components/link";
import Image from "components/image";

const Reviews = ({ data }) => {

  const settings = {
    loop: true,
    spaceBetween: 25,
    slidesPerView: 1,
    slidesPerGroup: 1,
    centeredSlides: true,
    modules: [Navigation, Pagination],
    autoHeight: true,
    pagination: { clickable: true },
    navigation: { clickable: true },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 30,
        pagination: false,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 35,
      },
      1025: {
        spaceBetween: 50,
        slidesPerView: 3,
      },
      1270: {
        spaceBetween: 20,
        slidesPerView: 3.5,
      }
    },
  };

  const { backgroundImage, review, link, title } = data;

  return (
    <div className={style.reviews} >
      <div className={style.reviewsImage} style={{ backgroundImage: `url(${getImagePath(backgroundImage, true)})` }}>
        <Container>
          <p className={style.reviewsTitle}>{title}</p>
          <div className={style.reviewsBox}>
            <Swiper {...settings} className={style.reviewsSlider}>
              {review.map((content, i) => (
                <SwiperSlide key={i} className={style.reviewsSlide}>
                  <div className={style.reviewsCardContainer} >

                    <div className={style.reviewsStars}>
                      <Image image={content?.stars} alt={content.stars?.alt} style={{ opacity: 1 }} />
                    </div>
                    <Card.Text className={style.reviewsDescription}>
                      <span style={{ opacity: 1 }}>{content.text}</span>
                    </Card.Text>
                    <Card.Title className={style.reviewsName}>
                      <h6 style={{ opacity: 1 }}>{content.name}</h6>
                    </Card.Title>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <Link to={link}><p>{locale.account.button.discoverNow}</p></Link>
        </Container>
      </div>
    </div>
  );
};

export default Reviews;